function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "color"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "hair"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "skin"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.187 0 0 1.188 -8.324 -10.3)",
  fill: "#fcea2b",
  stroke: "#fcea2b",
  strokeLinecap: "round",
  strokeWidth: 1.532,
  d: "m33.59 59.58c1.617 1.699 4.094-3.063 4.809-4.103 2.298 1.695 8.481 3.023 7.537-1.592 1.225 0.448 5.037 0.6612 3.849-3.45 3.047 1.486 5.646-0.8396 5.245-3.457 2.698 0.4885 4.347-1.715 3.588-4.344 4.063-5.1 3.828-11.69 3.595-14.66-0.7777-9.896-14.08-6.154-20.2-10.02l-12.99 0.05163c-2.202 3.942-3.569 1.824-7.728 2.337-6.072 0.8894-11.08 16.24-9.519 16.94l7.732 8.23c0.1394 1.526-3.91 4.042-0.3566 5.882 6.126 2.159 10.32 5.064 14.45 8.183z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "skin-shadow"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "line"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15.05 43.95s-7.133-5.822-8.537-8.259c-4.392-7.595 0.9489-19.79 10.44-21.82"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m38.71 42.99 12.89 7.021"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m33.87 47.79 13 6.498"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m58.18 45.72-5.1-4.358-8.279-4.335"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m37.49 56.29c8.574 5.466 10.79-0.2955 9.387-1.994 2.734 1.625 6.209-0.517 4.731-4.283 3.844 1.847 7.022-1.034 6.579-4.283 3.326 0.591 5.395-2.142 4.435-5.392 6.721-4.585 5.041-19.03-0.09878-25.36-9.287-1.459-11-2.362-20.98-3.943l-13.53-0.6185c-2.005-0.529-4.081 0.5703-4.779 2.533-0.7519 2.816-1.677 4.971-3.599 8.378-0.7286 1.786 0.1048 3.829 1.872 4.588 1.908 0.4767 2.78-0.386 4.46-1.686 2.195-2.102 2.628-2.996 3.805-4.575l13.64 6.204 12.72 7.164c2.514 1.698 5.012 5.844 6.51 7.321"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m31.51 54.15c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m25.84 50.98c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m20.18 47.82c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m14.53 44.65c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
}));

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.64002dea.svg";
export { ForwardRef as ReactComponent };